/**
 * ボードの表示有無を管理するStateを扱うモジュール
 */
import { ActionsUnion, createAction } from 'common/utils/action-utils';

export enum ActionTypes {
  SET_STATUS = 'app/board/SET_STATUS',
  SET_PLANID = 'app/board/SET_PLANID',
  SET_PURCHASEID_LENDING_USER = 'app/board/SET_PURCHASEID_LENDING_USER',
  SET_PURCHASEID_TERMINAL = 'app/board/SET_PURCHASEID_TERMINAL',
  SET_PURCHASEID_CANCEL = 'app/board/SET_PURCHASEID_CANCEL',
  SET_PURCHASEID_RETURN = 'app/board/SET_PURCHASEID_RETURN',
  SET_ON_CLICK_STATUS = 'app/board/SET_ON_CLICK_STATUS',
  SET_DEVICELIMIT = 'app/board/SET_DEVICELIMIT',
  SET_ACCOUNTPURCHASEID = 'app/board/SET_ACCOUNTPURCHASEID',
  SET_DELETE_INDEX = 'app/board/SET_DELETE_INDEX',
  SET_LENDER_DELETE = 'app/board/SET_LENDER_DELETE',
  SET_QUANTITY = 'app/board/SET_QUANTITY',
  SET_ALL_CHECK = 'app/board/SET_ALL_CHECK',
  SET_PLANNAME = 'app/board/SET_PLANNAME',
  SET_IS_INDVIDUALCANCEL = 'app/board/SET_IS_INDVIDUALCANCEL',
  SET_IS_PROCESSING = 'app/board/SET_IS_PROCESSING',
  IS_SELLOUT_PLAN = 'app/board/IS_SELLOUT_PLAN',
  SET_CANCEL_INDEX = 'app/board/SET_CANCEL_INDEX',
  SET_ALERT_MESSAGE = 'app/board/SET_ALERT_MESSAGE',
  IS_DEMO = 'app/board/IS_DEMO',
  SET_CHECK_INDEX = 'app/board/SET_CHECK_INDEX'
}

/**
 * ボードの表示状態を設定するのActionを作成する
 * @param {BoardStatus} payload ボード表示状態
 */
export const setStatus = (payload: BoardStatus) =>
  createAction(ActionTypes.SET_STATUS, payload);

/**
 * 表示中のプランIDを設定するActionを作成する
 * @param {string} planId 表示中のプランID
 */
export const setPlanId = (planId: string) =>
  createAction(ActionTypes.SET_PLANID, planId);

/**
 * ユーザー購入番号を設定するActionを作成する(「他ユーザーの管理/プランの解約」ダイアログ向け)
 * @param {string} purchaseId ユーザー購入番号(SAS)
 */
export const setPurchaseIdForLendingUser = (purchaseId: string) =>
  createAction(ActionTypes.SET_PURCHASEID_LENDING_USER, purchaseId);

/**
 * ユーザー購入番号を設定するActionを作成する(「デバイス管理」ダイアログ向け)
 * @param {string} purchaseId ユーザー購入番号(SAS)
 */
export const setPurchaseIdForTerminal = (purchaseId: string) =>
  createAction(ActionTypes.SET_PURCHASEID_TERMINAL, purchaseId);

/**
 * 解約するユーザー購入番号を設定するActionを作成する
 * @param {string} purchaseId 解約対象のユーザー購入番号(SAS)
 */
export const setPurchaseIdForCancel = (purchaseId: string) =>
  createAction(ActionTypes.SET_PURCHASEID_CANCEL, purchaseId);

/**
 * 利用権返却するユーザー購入番号を設定するActionを作成する
 * @param {string} purchaseId 返却対象のユーザー購入番号(SAS)
 */
export const setPurchaseIdForReturn = (purchaseId: string) =>
  createAction(ActionTypes.SET_PURCHASEID_RETURN, purchaseId);

/**
 * 国・言語ボタンが押下状態を設定するActionを作成する
 * @param {boolean} isClick ボタンの押下状態
 */
export const setOnClickStatus = (status: ButtonStatus) =>
  createAction(ActionTypes.SET_ON_CLICK_STATUS, status);

/**
 * 表示中のプランのデバイス制限上限を設定するActionを作成する
 * @param {number} deviceLimit デバイス上限
 */
export const setDeviceLimit = (deviceLimit: number) =>
  createAction(ActionTypes.SET_DEVICELIMIT, deviceLimit);

/**
 * 表示中のプランの購入数量を設定するActionを作成する
 * @param {number} quantity 購入数量
 */
export const setQuantity = (quantity: number) =>
  createAction(ActionTypes.SET_QUANTITY, quantity);

/**
 * 表示する貸与ユーザーの購入番号を設定するActionを作成する
 * @param {string} purchaseId 解約対象のユーザー購入番号(SAS)
 */
export const setAccountPurchaseId = (purchaseId: string) =>
  createAction(ActionTypes.SET_ACCOUNTPURCHASEID, purchaseId);

/**
 * 削除するインデックス番号を設定するActionを作成する
 * @param {string[]} deleteIndex 削除するユーザー
 */
export const setDeleteIndex = (deleteIndex: string[]) =>
  createAction(ActionTypes.SET_DELETE_INDEX, deleteIndex);

/**
 * 第三者ユーザーの削除完了ボードを表示時に貸与者と貸与されたユーザーどちらが削除したかどうか
 */
export const setLenderDelete = (lenderDelete: boolean) =>
  createAction(ActionTypes.SET_LENDER_DELETE, lenderDelete);

/**
 * 表示中のプラン名を設定するActionを作成する
 * @param {string} planName プラン名
 */
export const setPlanName = (planName: string) =>
  createAction(ActionTypes.SET_PLANNAME, planName);

/**
 * 個別解約であるか否かを設定するActionを作成する
 * @param {boolean} isIndividualCancel 個別解約であるか否か
 */
export const setIsIndividualCancel = (isIndividualCancel: boolean) =>
  createAction(ActionTypes.SET_IS_INDVIDUALCANCEL, isIndividualCancel);

/**
 * 処理中であるか否かを設定するActionを作成する
 * @param {boolean} isProcessing 処理中であるか否か(ポップアップのbackgroundクリック時の制御に使用)
 */
export const setIsProcessing = (isProcessing: boolean) =>
  createAction(ActionTypes.SET_IS_PROCESSING, isProcessing);

/**
 * 売り切りプランであるか否かを設定するActionを作成する
 * @param {boolean} isSelloutPlan 売り切りプランであるか否か
 */
export const setIsSelloutPlan = (isSelloutPlan: boolean) =>
  createAction(ActionTypes.IS_SELLOUT_PLAN, isSelloutPlan);

/**
 * 解約するインデックス番号を設定するActionを作成する
 * @param {string[]} deleteIndex 削除するユーザー
 */
export const setCancelIndex = (cancelIndex: string[]) =>
  createAction(ActionTypes.SET_CANCEL_INDEX, cancelIndex);

/**
 * 警告メッセージを設定するActionを作成する
 * @param {string} alertMessage 警告メッセージ
 */
export const setAlertMessage = (alertMessage: string) =>
  createAction(ActionTypes.SET_ALERT_MESSAGE, alertMessage);

/**
 * デモプランであるか否かを確認するActionを作成する
 * @param {boolean} isDemo デモプランであるか否か
 */
export const setIsDemo = (isDemo: boolean) =>
  createAction(ActionTypes.IS_DEMO, isDemo);

/**
 * 他ユーザーの管理/プランの解約ボードのインデックス番号を設定するActionを作成する
 * @param {string[]} checkIndex チェックするインデックス
 */
export const setCheckIndex = (checkIndex: string[]) =>
  createAction(ActionTypes.SET_CHECK_INDEX, checkIndex);

const actions = {
  setStatus,
  setPlanId,
  setPurchaseIdForLendingUser,
  setPurchaseIdForTerminal,
  setPurchaseIdForCancel,
  setPurchaseIdForReturn,
  setOnClickStatus,
  setDeviceLimit,
  setQuantity,
  setAccountPurchaseId,
  setLenderDelete,
  setPlanName,
  setDeleteIndex,
  setIsIndividualCancel,
  setIsProcessing,
  setIsSelloutPlan,
  setCancelIndex,
  setAlertMessage,
  setIsDemo,
  setCheckIndex
};
type BoardAction = ActionsUnion<typeof actions>;

export enum BoardStatus {
  /** ボードを表示しない */
  NOT_DISP,
  /** 初回アクセスボードを表示 */
  FIRST_DISP,
  /** 国地域選択ボードを表示 */
  COUNTRY_DISP,
  /** 言語選択ボードを表示 */
  LANGUAGE_DISP,
  /** 言語選択ボードを表示(初回アクセスボード経由) */
  LANGUAGE_FROM_FIRST_DISP,
  /** メニューボードを表示 */
  MENU_DISP,
  /** ユーザーボードを表示 */
  USER_DISP,
  /** 購入確認ボードを表示 */
  BEFORE_PURCHASE_DISP,
  /** 解約確認ボードを表示 */
  BEFORE_CANCEL_DISP,
  /** 貸与ユーザー一覧ボード表示 */
  LENDING_USER_DISP,
  /** 貸与ユーザー追加ボード表示 */
  ADD_LENDING_USER_DISP,
  /** 貸与ユーザー追加操作完了ボード表示 */
  COMPLETION_ADD_LENDING_USER_DISP,
  /** 貸与ユーザー削除ボード表示 */
  DELETE_LENDING_USER_DISP,
  /** 貸与ユーザー削除操作完了ボード表示 */
  COMPLETION_DELETE_LENDING_USER_DISP,
  /** 貸与ユーザー登録解除ボード表示 */
  DEACTIVATE_LENDING_USER_DISP,
  /** 端末管理ボードを表示 */
  TERMINAL_DISP,
  /** 端末管理ボード上に確認ダイアログを表示 */
  TERMINAL_CONFIRMATION_DISP,
  /** 端末管理ボード上に成功ダイアログを表示 */
  TERMINAL_SUCCESS_DISP,
  /** 端末管理ボード上に失敗ダイアログを表示 */
  TERMINAL_FAILURE_DISP,
  /** 個別解約ボード表示 */
  BEFORE_INDIVIDUAL_CANCEL_DISP,
  /** 個別解約操作完了ボード表示 */
  COMPLETION_BEFORE_INDIVIDUAL_CANCEL_DISP,
  /** 利用解除確認ダイアログ表示 */
  CANCELLATION_CONFIRMATION_DISP,
  /** 機能のアクティベート管理ボードを表示 */
  DEVICE_ACTIVATE_DISP,
  /** アクティベーションファイルのダウンロード時の確認ダイアログを表示 */
  DEVICE_ACTIVATE_DOWNLOAD_CONFIRMATION_DISP,
  /** 有償ファームウェアのアクティベート予約API/有償ファームウェアのアクティベート確定APIの実行結果のエラーダイアログを表示  */
  DEVICE_ACTIVATE_API_ERROR_COMPLETION_DISP,
  /** リクエストファイルアップロード時のファイル読み込みエラーダイアログを表示 */
  DEVICE_ACTIVATE_FILE_LOADING_ERROR_DISP,
  /** リクエストファイルアップロード時の確認ダイアログ/リクエストファイルアップロード時の確認ダイアログ(エラー含む)/リクエストファイルアップロード後のエラーダイアログを表示  */
  DEVICE_ACTIVATE_UPLOAD_RESULT_DISP,
  /** リクエストファイル削除時の確認ダイアログを表示 */
  DEVICE_ACTIVATE_DELETE_CONFIRMATION_DISP
}

export enum ButtonStatus {
  // 未選択
  NO_SELECT,
  // 国選択
  ON_CLICK_COUNTRY,
  // 言語選択
  ON_CLICK_LANGUAGE
}

export interface LendingUserBoardIndexMap {
  /** インデックスのチェック情報 */
  checkIndex: string[];
  /** 削除するユーザーの情報 */
  deleteIndex: string[];
  /** 解約するユーザーの情報 */
  cancelIndex: string[];
}

/**
 * ボード表示有無のState
 */
export interface boardState {
  /** 表示状態 */
  status: BoardStatus;
  /** 選択中のプランID */
  selectedPlanId: string;
  /** 選択中のユーザー購入番号(「他ユーザーの管理/プランの解約」ダイアログ向け) */
  selectedPurchaseIdForLendingUser: string;
  /** 選択中のユーザー購入番号(「デバイス管理」ダイアログ向け) */
  selectedPurchaseIdForTerminal: string;
  /** 選択中のユーザー購入番号(全解約ボタン向け) */
  selectedPurchaseIdForCancel: string;
  /** 選択中のユーザー購入番号(購入者に返却ボタン向け) */
  selectedPurchaseIdForReturn: string;
  /** ボタンの押下状態 */
  clickStatus: ButtonStatus;
  /** 選択中のデバイス上限 */
  selectedDeviceLimit: number;
  /** 選択中の購入数量 */
  selectedQuantity: number;
  /** 表示する貸与ユーザーの購入番号 */
  selectedAccountPurchaseId: string;
  /** 貸与者と貸与されたユーザーどちらが削除したか */
  lenderDelete: boolean;
  /** 選択中のプラン名 */
  planName: string;
  /** 個別解約であるか否か */
  isIndividualCancel: boolean;
  /** 処理中であるか否か */
  isProcessing: boolean;
  /** 売り切りプランであるか否か */
  isSelloutPlan: boolean;
  /** 警告メッセージ */
  alertMessage: string;
  /** デモプランであるか否か */
  isDemo: boolean;
  /** 他ユーザーの管理/プランの解約ボードのインデックス情報 */
  lendingIndex: LendingUserBoardIndexMap;
}

const initialState: boardState = {
  status: BoardStatus.NOT_DISP,
  selectedPlanId: '',
  selectedPurchaseIdForLendingUser: '',
  selectedPurchaseIdForTerminal: '',
  selectedPurchaseIdForCancel: '',
  selectedPurchaseIdForReturn: '',
  clickStatus: ButtonStatus.NO_SELECT,
  selectedDeviceLimit: 0,
  selectedQuantity: 0,
  selectedAccountPurchaseId: '',
  lenderDelete: false,
  planName: '',
  isIndividualCancel: false,
  isProcessing: false,
  isSelloutPlan: false,
  alertMessage: '',
  isDemo: false,
  lendingIndex: {
    checkIndex: [],
    deleteIndex: [],
    cancelIndex: []
  } as LendingUserBoardIndexMap
};

export default (
  state: boardState = initialState,
  action: BoardAction
): boardState => {
  switch (action.type) {
    case ActionTypes.SET_STATUS:
      return { ...state, status: action.payload };
    case ActionTypes.SET_PLANID:
      return { ...state, selectedPlanId: action.payload };
    case ActionTypes.SET_PURCHASEID_LENDING_USER:
      return { ...state, selectedPurchaseIdForLendingUser: action.payload };
    case ActionTypes.SET_PURCHASEID_TERMINAL:
      return { ...state, selectedPurchaseIdForTerminal: action.payload };
    case ActionTypes.SET_PURCHASEID_CANCEL:
      return { ...state, selectedPurchaseIdForCancel: action.payload };
    case ActionTypes.SET_PURCHASEID_RETURN:
      return { ...state, selectedPurchaseIdForReturn: action.payload };
    case ActionTypes.SET_ON_CLICK_STATUS:
      return { ...state, clickStatus: action.payload };
    case ActionTypes.SET_ACCOUNTPURCHASEID:
      return { ...state, selectedAccountPurchaseId: action.payload };
    case ActionTypes.SET_QUANTITY:
      return { ...state, selectedQuantity: action.payload };
    case ActionTypes.SET_LENDER_DELETE:
      return { ...state, lenderDelete: action.payload };
    case ActionTypes.SET_PLANNAME:
      return { ...state, planName: action.payload };
    case ActionTypes.SET_DEVICELIMIT:
      return { ...state, selectedDeviceLimit: action.payload };
    case ActionTypes.SET_DELETE_INDEX: {
      const modifiedState = { ...state };
      modifiedState.lendingIndex.deleteIndex = action.payload;
      return modifiedState;
    }
    case ActionTypes.SET_IS_INDVIDUALCANCEL:
      return { ...state, isIndividualCancel: action.payload };
    case ActionTypes.SET_IS_PROCESSING:
      return { ...state, isProcessing: action.payload };
    case ActionTypes.IS_SELLOUT_PLAN:
      return { ...state, isSelloutPlan: action.payload };
    case ActionTypes.SET_CANCEL_INDEX: {
      const modifiedState = { ...state };
      modifiedState.lendingIndex.cancelIndex = action.payload;
      return modifiedState;
    }
    case ActionTypes.SET_ALERT_MESSAGE:
      return { ...state, alertMessage: action.payload };
    case ActionTypes.IS_DEMO:
      return { ...state, isDemo: action.payload };
    case ActionTypes.SET_CHECK_INDEX: {
      const modifiedState = { ...state };
      modifiedState.lendingIndex.checkIndex = action.payload;
      return modifiedState;
    }
    default:
      return state;
  }
};
